// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"fe37e2eb","453":"8c049eda"}[chunkId] + ".chunk.js";
};